export const MODE_NAVIGATION = {
  list: 'LIST',
  tree: 'TREE',
};
